import React from 'react';
import MessageView from './message-view';

class FirstMessageView extends React.PureComponent {
    render() {
        return (
            <MessageView
                isFirstMessage={true}
                {...this.props}
                />
        );
    }
}

export default FirstMessageView;
